import { PropType, defineComponent } from 'vue'

import { CsTag, MsHeadline } from '@sunrise/components'
import { MsDoor, MsFloorPlan, MsImage, MsSurface } from '@sunrise/icons'
import { screenSizeDetection } from '@sunrise/shared'
import { MLM, trackLink } from '@sunrise/tracking'

import { DecoratedEstate } from '../../ts/mapper/decoratedItemEstate.interface'
import { createArrayFromString } from '../../ts/utils/stringUtils'

import MsFallbackSvg from '../../static/illus/fallback.svg?component'
import MsImmoweltBadge from '../../static/illus/immoweltBadge.svg?component'
import MsDynamicTags from '../MsDynamicTags/MsDynamicTags.vue'
import MsLikeButton from '../MsLikeButton/MsLikeButton.vue'
import { ComponentName } from './MsResultListItem.enum'
import { buildMlmTrackingData, buildTealiumTrackingData } from './MsResultListItemTracking'

export default defineComponent({
    name: 'MsResultListItem',
    components: {
        CsTag,
        MsLikeButton,
        MsFallbackSvg,
        MsDoor,
        MsDynamicTags,
        MsFloorPlan,
        MsHeadline,
        MsImage,
        MsSurface,
        MsImmoweltBadge,
    },
    props: {
        item: { type: Object as PropType<DecoratedEstate>, required: true },
        currentUrl: {
            type: String,
            required: true,
        },
        parentComponent: {
            type: String as PropType<ComponentName>,
            required: true,
        },
        isExposeeOnline: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    setup(props) {
        const { isScreenM } = screenSizeDetection()

        const badgeText = `${props.item.imageCount} ${props.item.imageCount === 1 ? 'Bild' : 'Bilder'}`

        const equipmentArray = props.item.equipmentAsString
            ? createArrayFromString(props.item.equipmentAsString, ', ')
            : ['Keine Angaben zur Ausstattung']

        function showLandArea(): boolean {
            return props.item.livingArea == null || props.item.rooms == null
        }

        function getOfferType(): string {
            return props.item.commercialExpose ? 'gewerbliches' : 'privates'
        }

        function onClickItem(e: MouseEvent): void {
            trackTealium(e)
            trackMlm()
        }

        function trackTealium(e: MouseEvent): void {
            const target = e.currentTarget as HTMLAnchorElement
            const tealiumData = buildTealiumTrackingData(props.item, props.parentComponent, props.isExposeeOnline)
            trackLink(e, target, [tealiumData])
        }

        function trackMlm(): void {
            const mlmData = buildMlmTrackingData(
                props.item,
                props.currentUrl,
                props.parentComponent,
                props.isExposeeOnline,
            )
            MLM.trackClick(mlmData)
        }

        return {
            isScreenM,
            badgeText,
            equipmentArray,
            showLandArea,
            getOfferType,
            onClickItem,
        }
    },
})
